import {faFacebook, faGithub, faLinkedin} from "@fortawesome/free-brands-svg-icons";

// import avt from '../assets/images/onepage-personal-avatar.jpg'
import avt from '../assets/images/golang.png'
import cover from '../assets/images/golang.png'

import bg1 from '../assets/images/portfolio-simple-2-p1.jpg'
import bg2 from '../assets/images/portfolio-simple-2-p2.jpg'
import bg3 from '../assets/images/portfolio-simple-2-p3.jpg'
import bg4 from '../assets/images/portfolio-simple-2-p4.jpg'
import bg5 from '../assets/images/portfolio-simple-2-p5.jpg'
import bg6 from '../assets/images/portfolio-simple-2-p6.jpg'

export const shortInfo = {
    name: "Le Duong Khang",
    major: "Software Engineering",
    avatar: avt,
    cover: cover,
}

export const socialIcon = [
    {
        id: 1,
        link: "https://facebook.com/duong.khang.161",
        icon: faFacebook,
    },
    {
        id: 2,
        link: "https://www.linkedin.com/in/hidding... :))",
        icon: faLinkedin,
    },
    {
        id: 3,
        link: "https://github.com/khangjig",
        icon: faGithub,
    },
    // {
    //     id: 4,
    //     link: "https://www.twitter.com/not-yet",
    //     icon: faTwitter,
    // }
]

export const scores = [
    {
        id: 1,
        score: 0,
        name: "You",
    },
    {
        id: 2,
        score: 8,
        name: "Must",
    },
    {
        id: 3,
        score: 1,
        name: "Had",
    },
    {
        id: 4,
        score: 2,
        name: "Have",
    },
    {
        id: 5,
        score: 9,
        name: "A Broken",
    },
    {
        id: 6,
        score: 7,
        name: "Heart",
    },
]

export const skills = [
    {
        id: 1,
        name: "Golang",
        rate: "80%"
    },
    {
        id: 2,
        name: "Javascript",
        rate: "80%"
    },
    {
        id: 3,
        name: "PHOTOSHOP",
        rate: "85%"
    }
]

export const introduction = [
    {
        id: 1,
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },
    {
        id: 2,
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }
]

export const timelines = [
    {
        id: 1,
        from: "3/2020",
        to: "Present",
        title: "Role @ Company",
        description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa."
    },
    {
        id: 2,
        from: "6/2019",
        to: "12/2019",
        title: "Role @ Company",
        description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa."
    },
    {
        id: 3,
        from: "3/2019",
        to: "6/2019",
        title: "Role @ Company",
        description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa."
    },
    {
        id: 4,
        from: "9/2015",
        to: "2019",
        title: "Role @ Company",
        description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa."
    },
    {
        id: 5,
        from: "2011",
        to: "2015",
        title: "Role @ Company",
        description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa."
    }
]

export const posts = [
    {
        id: 1,
        cover: bg1,
        title: "Project Title",
        category: "Category"
    },
    {
        id: 2,
        cover: bg2,
        title: "Project Title",
        category: "Category"
    },
    {
        id: 3,
        cover: bg3,
        title: "Project Title",
        category: "Category"
    },
    {
        id: 4,
        cover: bg4,
        title: "Project Title",
        category: "Category"
    },
    {
        id: 5,
        cover: bg5,
        title: "Project Title",
        category: "Category"
    },
    {
        id: 6,
        cover: bg6,
        title: "Project Title",
        category: "Category"
    }
]